<template>
  <FormContainer withoutDivider>
    <template #title>L'emploi occupé ( rappel des éléments constitutifs du contrat de travail)</template>
    <template #content>
      <div class="form__bloc">
        <WrapperInput
          id="field_68"
          v-model="emploiOccupeModel"
          label="Emploi occupé pendant le contrat (intitulé précis)"
          :required="meta.contrat?.emploiOccupe?.$status === PropertyStatus.Required"
          :alertLabel="meta.contrat?.emploiOccupe?.$messageErreurDirty!"
          :maxlength="200"
          deletable
          :readonly
          class="col-18 col-md-18 col-sm-36"
        />
        <WrapperInput
          id="field_69"
          v-model="emploiCcnModel"
          label="Classification de l'emploi dans la convention collective"
          :required="meta.contrat?.emploiCcn?.$status === PropertyStatus.Required"
          :alertLabel="meta.contrat?.emploiCcn?.$messageErreurDirty!"
          :maxlength="200"
          deletable
          :readonly
          class="col-18 col-md-18 col-sm-36"
        />
      </div>
      <div class="form__bloc">
        <WrapperInput
          id="field_70"
          v-model="niveauQualificationCcnModel"
          label="Niveau"
          :required="meta.contrat?.niveauQualificationCcn?.$status === PropertyStatus.Required"
          :alertLabel="meta.contrat?.niveauQualificationCcn?.$messageErreurDirty!"
          :maxlength="15"
          deletable
          :readonly
          class="col-12 col-md-18 col-sm-36"
        />
        <WrapperInput
          id="field_71"
          v-model="coefficientCcnModel"
          label="Coefficient hiérarchique"
          :required="meta.contrat?.coefficientCcn?.$status === PropertyStatus.Required"
          :alertLabel="meta.contrat?.coefficientCcn?.$messageErreurDirty!"
          :maxlength="200"
          deletable
          :readonly
          class="col-12 col-md-18 col-sm-36"
        />
        <WrapperInputDate
          id="field_72"
          v-model="dateDebutExecutionContratModel"
          label="Date de début d'éxécution du contrat de travail"
          :required="meta.contrat?.dateDebutExecutionContrat?.$status === PropertyStatus.Required"
          :alertLabel="meta.contrat?.dateDebutExecutionContrat?.$messageErreurDirty!"
          :hint="HINT_DATE"
          class="col-12 col-md-18 col-sm-36"
          :placeholder="PLACEHOLDER_DATE"
          deletable
          :readonly
        />
      </div>
    </template>
  </FormContainer>
</template>

<script setup lang="ts">
  import { PropertyStatus } from '@/features/domaine/property-status/PropertyStatus'
  import { FormContainer, HINT_DATE, PLACEHOLDER_DATE } from '@/features/interface/demande/shared'
  import { storeToRefs } from 'pinia'
  import { useDemandePROAStore } from '../../../../useDemandePROAStore'

  const store = useDemandePROAStore()
  const { setupFieldWithKey } = store
  const { meta, readonly } = storeToRefs(store)

  const emploiOccupeModel = setupFieldWithKey<string>('contrat.emploiOccupe', true)
  const emploiCcnModel = setupFieldWithKey<string>('contrat.emploiCcn', true)
  const niveauQualificationCcnModel = setupFieldWithKey<string>('contrat.niveauQualificationCcn', false)
  const coefficientCcnModel = setupFieldWithKey<string>('contrat.coefficientCcn', true)
  const dateDebutExecutionContratModel = setupFieldWithKey<string>('contrat.dateDebutExecutionContrat', true)
</script>
